import { CarouselManager } from "../utils/carouselManager";

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.displayMode = this.getAttribute("data-display-mode") || "manual";
    this.interval = this.getAttribute("data-interval") || 3000;
  }

  connectedCallback() {
    console.log("AnnouncementBar connected");
    this.initSlider();
  }

  async initSlider() {
    const splideEl = this.querySelector("#slider-announcement");

    if (!splideEl || typeof CarouselManager === "undefined") {
      console.warn("Splide element or CarouselManager missing");
      return;
    }

    const options = {
      arrows: false,
      pagination: false,
      fixedWidth: "100%",
      autoHeight: true,
      drag: false,
      lazyload: "nearby",
      preloadPages: 1,
      rewind: true
    };

    if (this.displayMode != "manual") {
      options.autoplay = 'play';
      options.interval = this.interval;
    }

    this.slider = await CarouselManager.create(splideEl, options);

    const header = this.closest("g-header");
    if (header) {
      header.calcScrollOffset();
    }
    if (this.displayMode === "manual") {
      this.initSliderArrows();
    }
  }

  initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav-announcement");
    if (!sliderNavEl || !this.slider) {
      console.warn("No slider nav or slider found");
      return;
    }

    const navNextBtn = sliderNavEl.querySelector(".nav-next");
    const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

    navNextBtn?.addEventListener("click", () => {
      this.slider.go(">");
    });

    navPrevBtn?.addEventListener("click", () => {
      this.slider.go("<");
    });
  }
}

if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementBar);
}